module.exports = __webpack_public_path__ + "img/Blog Thumb.8579b15a.png";